/// <reference path="../../../teva/datepicker/datepicker.ts" />
/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../../teva/navigation/navigation.ts" />
/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../common/common/common.ts" />

namespace OfficeGuy.Apps {
    declare var FullCalendar;

    export class Calendar {
        static GetScripts(Scripts, Index, Callback) {
            $.getScript(Scripts[Index], function () {
                if (++Index == Scripts.length)
                    Callback();
                else
                    Calendar.GetScripts(Scripts, Index, Callback);
            });
        }

        static Init(CalendarSelector, CalendarPropertyID, Calendars, GoogleCalendarIDs, ShowHebrewDates, ShowJewishEvents, WorkingHours_From, WorkingHours_To) {
            Calendar.GetScripts(["/scripts/fullcalendar/fullcalendar.min.js",
                "/scripts/fullcalendar/he.js",
                "/scripts/fullcalendar/daygrid.min.js",
                "/scripts/fullcalendar/timegrid.min.js",
                "/scripts/fullcalendar/list.min.js",
                "/scripts/fullcalendar/interaction.min.js",
                "/scripts/fullcalendar/gcal.min.js"], 0,
                function () {
                    var EventSources = new Array();
                    var DefaultView = Teva.Storage.LocalStorage_Get("CalendarView");
                    if (DefaultView == null)
                        DefaultView = "listWeek";
                    var EventSources = new Array();
                    if (ShowHebrewDates) {
                        EventSources.push({
                            cache: true,
                            googleCalendarId: "donkey.co.il_jclf8se97q8tp0hhpdq4btv6jo@group.calendar.google.com",
                            googleCalendarApiKey: "AIzaSyBj-Iem7SWqtbrCWezcpqwerQteEtfjsIE",
                            editable: false,
                            className: "og-calendar-google og-calendar-hebrew",
                            eventDataTransform: function (eventData) {
                                eventData.sort = "1";
                                return eventData;
                            }
                        });
                    }
                    if (ShowJewishEvents) {
                        EventSources.push({
                            googleCalendarId: "en.jewish#holiday@group.v.calendar.google.com",
                            googleCalendarApiKey: "AIzaSyBj-Iem7SWqtbrCWezcpqwerQteEtfjsIE",
                            editable: false,
                            className: "og-calendar-google og-calendar-jewish",
                        });
                    }
                    EventSources.push({
                        "events": function (fetchInfo, callback) {
                            var CalendarIDs = "";
                            for (var i = 0; i < Calendars.length; i++)
                                CalendarIDs += "," + Calendars[i].ID;
                            Common.AjaxRequest({
                                Method: 'GET',
                                URL: "/calendar/getdata/?calendarids=" + CalendarIDs + "&start=" + fetchInfo.startStr + "&end=" + fetchInfo.endStr,
                                SuccessMethod: function (Response) {
                                    callback(Response);
                                },
                                Data: {
                                    CalendarIDs: CalendarIDs,
                                    Start: fetchInfo.startStr,
                                    End: fetchInfo.endStr
                                }
                            });
                        }
                    });
                    if (GoogleCalendarIDs != null && GoogleCalendarIDs.length > 0) {
                        GoogleCalendarIDs = GoogleCalendarIDs.split(',');
                        for (var i = 0; i < GoogleCalendarIDs.length; i++) {
                            EventSources.push({
                                googleCalendarId: GoogleCalendarIDs[i],
                                googleCalendarApiKey: "AIzaSyBj-Iem7SWqtbrCWezcpqwerQteEtfjsIE",
                                editable: false
                            });
                        }
                    }
                    var Calendar = new (<any>FullCalendar).Calendar($(CalendarSelector)[0], {
                        plugins: ['dayGrid', 'timeGrid', 'list', 'interaction', 'googleCalendar'],
                        eventSources: EventSources,
                        eventOrder: "sort,title",
                        header: {
                            left: "title",
                            center: "dayGridMonth,timeGridWeek,timeGridSixDay,timeGridFiveDay,customListWeek,listDay",
                            right: "today next,prev"
                        },
                        views: {
                            customListWeek: {
                                type: 'listWeek',
                                buttonText: 'סדר שבוע',
                            },
                            timeGridFiveDay: {
                                type: 'timeGridWeek',
                                buttonText: "ראשון-חמישי",
                                hiddenDays: [5, 6]
                            },
                            timeGridSixDay: {
                                type: 'timeGridWeek',
                                buttonText: "ראשון-שישי",
                                hiddenDays: [6]
                            }
                        },
                        defaultView: DefaultView,
                        locale: "he",
                        //slotLabelFormat: "HH:mm",
                        //timeFormat: "HH:mm",
                        dir: "rtl",
                        eventTimeFormat: {
                            hour: '2-digit',
                            minute: '2-digit',
                            meridiem: false
                        },
                        minTime: WorkingHours_From,
                        maxTime: WorkingHours_To,
                        eventClick: function (Info) {
                            if (Info.event.extendedProps.schemaId == null)
                                return false;
                            if ($(Info.jsEvent.target).is("a tr.fc-list-item"))
                                return true;

                            var URL = "/f" + Info.event.extendedProps.schemaId + "/c" + Info.event.id + "/";
                            if (Teva.Navigation.IsNewWindowEvent(Info.jsEvent)) {
                                window.open(URL);
                                return false;
                            }

                            OfficeGuy.Modals.ShowURLModal(URL);
                            return false;
                        },
                        datesRender: function (Info) {
                            Teva.Storage.LocalStorage_Set("CalendarView", Info.view.type);
                        },
                        editable: true,
                        eventDrop: function (Info) {
                            Common.AjaxRequest({
                                URL: "/calendar/updateevent/",
                                ShowLoading: true,
                                Data: {
                                    ID: Info.event.id,
                                    OffsetMinutes: Apps.Calendar.DeltaToMinutes(Info.delta),
                                    CalendarID: Info.event.extendedProps.calendarId
                                },
                            });
                        },
                        eventResize: function (Info) {
                            Common.AjaxRequest({
                                URL: "/calendar/updateevent/",
                                ShowLoading: true,
                                Data: {
                                    ID: Info.event.id,
                                    ExtendMinutes: Apps.Calendar.DeltaToMinutes(Info.endDelta),
                                    CalendarID: Info.event.extendedProps.calendarId
                                },
                            });
                        },
                        eventRender: function (Info) {
                            var title = $(Info.el).find('.fc-title');
                            title.html(title.text());
                        },
                        selectable: true,
                        select: function (Info) {
                            // Missing Calendar Selection
                            if (Calendars.length == 1) {
                                var Calendar = Calendars[0];
                                var URL = "/f" + Calendar.Folder.ID + "/new/?";
                                URL += "relatedpropertyid=" + CalendarPropertyID + "&&relatedentityid=" + Calendar.ID;
                                URL += "&defaultproperty_1=" + Calendar.StartDateProperty.PropertyID + "&defaultvalue_1=" + Teva.DatePicker.GetDateTimeAsString(Info.start);
                                URL += "&defaultproperty_2=" + Calendar.EndDateProperty.PropertyID + "&defaultvalue_2=" + Teva.DatePicker.GetDateTimeAsString(Info.end);

                                OfficeGuy.Modals.ShowURLModal(URL);
                            }
                            else {
                                var $HTML = $(document.createElement('div')
                                    .addClass("modal-buttonspanel"));
                                for (var i = 0; i < Calendars.length; i++) {
                                    var Calendar = Calendars[i];
                                    var URL = "/f" + Calendar.Folder.ID + "/new/?";
                                    URL += "relatedpropertyid=" + CalendarPropertyID + "&&relatedentityid=" + Calendar.ID;
                                    URL += "&defaultproperty_1=" + Calendar.StartDateProperty.PropertyID + "&defaultvalue_1=" + Teva.DatePicker.GetDateTimeAsString(Info.start);
                                    URL += "&defaultproperty_2=" + Calendar.EndDateProperty.PropertyID + "&defaultvalue_2=" + Teva.DatePicker.GetDateTimeAsString(Info.end);
                                    $HTML.append($(document.createElement('a')
                                            .addClass("modal-buttonspanel-item")
                                            .attr("href", "#")
                                            .setText(Calendar.CalendarName)
                                        )
                                        .on("click", function () {
                                            OfficeGuy.Modals.ShowURLModal(URL);
                                        })
                                    );
                                }

                                OfficeGuy.Modals.ShowHTMLDialog({
                                    Title: 'בחירת יומן',
                                    HTML: $HTML
                                }); return false;
                            }
                        }
                    });
                    Calendar.render();
                });
        }
        static DeltaToMinutes(Delta) {
            return Delta.milliseconds / (1000 * 60) + Delta.days * 24 * 60;
        }

        static InitEditor() {
            $(".og-calendar-edit-folder .schemapicker").on("change", function () {
                OfficeGuy.Apps.Calendar.SchemaChanged($(this).val());
            });
            OfficeGuy.Apps.Calendar.SchemaChanged($(".og-calendar-edit-folder .schemapicker").val());
        }

        static SchemaChanged(SchemaID): void {
            var SchemaID = SchemaID;
            var Schema = Teva.SelectBox.GetInstance($(".og-calendar-edit-folder .schemapicker"));
            Teva.SelectBox.GetInstance($(".og-calendar-edit-filtersview .schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText)
            Teva.SelectBox.GetInstance($(".og-calendar-edit-startdate .schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText);
            Teva.SelectBox.GetInstance($(".og-calendar-edit-enddate .schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText);
            Teva.SelectBox.GetInstance($(".og-calendar-edit-name .schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText);
            $(".og-calendar-edit-shownproperties .schemapicker").each(function () {
                Teva.SelectBox.GetInstance($(this)).SetValue(Schema.SelectedValue, Schema.SelectedText);
            });

        }

        static InitPushEndDate($StartDate, $EndDate) {
            $StartDate.data("prev", $StartDate.val());
            $StartDate.on("change", function () {
                var PreviousStartDate = Teva.DatePicker.GetDateFromString($StartDate.data("prev"), Teva.DatePickerMode.DateTime);
                var NewStartDate = Teva.DatePicker.GetDateFromString($StartDate.val(), Teva.DatePickerMode.DateTime);
                var PreviousEndDate = Teva.DatePicker.GetDateFromString($EndDate.val(), Teva.DatePickerMode.DateTime);
                if (PreviousStartDate != null && NewStartDate != null && PreviousEndDate != null) {
                    PreviousEndDate.setTime(PreviousEndDate.getTime() + (NewStartDate.getTime() - PreviousStartDate.getTime()));
                    $EndDate.val(Teva.DatePicker.GetDateTimeAsString(PreviousEndDate));
                }

                $StartDate.data("prev", $StartDate.val());
            });
        }
    }
}
